import AllConversation from "./components/AllConversation/AllConversation";
import HeaderChat from "./components/HeaderChat/HeaderChat";
import HeaderHome from "./components/HeaderHome/HeaderHome";
import styles from "./Header.module.scss";

export default function Header() {

  return (
    <div className={`${styles.container} header-all`}>
      <div className={`${styles["container-header"]}`}>
        <HeaderHome></HeaderHome>
      </div>
      <div className={`${styles["container-header"]}`}>
        <AllConversation></AllConversation>
      </div>
      <div className={`${styles["container-header"]}`}>
        <HeaderChat></HeaderChat>
      </div>
    </div>

  )
}
